import axios from "axios";

const API_URL = process.env.REACT_APP_APIHOST || "http://localhost:3033";

// Helper to get auth header
const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return { headers: { Authorization: `Bearer ${token}` } };
};

const userService = {
    // Get all users
    getAllUsers: async () => {
        try {
            const response = await axios.get(`${API_URL}/users`, getAuthHeader());
            return response.data;
        } catch (error) {
            throw error.response?.data || { errorMessage: "Failed to fetch users" };
        }
    },

    // Get user by ID
    getUserById: async (id) => {
        try {
            const response = await axios.get(`${API_URL}/users/${id}`, getAuthHeader());
            return response.data;
        } catch (error) {
            throw error.response?.data || { errorMessage: "Failed to fetch user" };
        }
    },

    // Create new user
    createUser: async (userData) => {
        try {
            const response = await axios.post(`${API_URL}/users`, userData, getAuthHeader());
            return response.data;
        } catch (error) {
            throw error.response?.data || { errorMessage: "Failed to create user" };
        }
    },

    // Update user
    updateUser: async (id, userData) => {
        try {
            const response = await axios.put(`${API_URL}/users/${id}`, userData, getAuthHeader());
            return response.data;
        } catch (error) {
            throw error.response?.data || { errorMessage: "Failed to update user" };
        }
    },

    // Delete user
    deleteUser: async (id) => {
        try {
            const response = await axios.delete(`${API_URL}/users/${id}`, getAuthHeader());
            return response.data;
        } catch (error) {
            throw error.response?.data || { errorMessage: "Failed to delete user" };
        }
    },
};

export default userService;
